import { useState, type ReactNode } from "react";

import type { CopyText } from "@/copy";

export function Chapter({
  id,
  title,
  takeaway,
  extra,
  defaultOpen = false,
  t,
  children,
}: {
  id: string;
  title: string;
  takeaway?: string;
  extra?: ReactNode;
  defaultOpen?: boolean;
  t: CopyText;
  children: ReactNode;
}) {
  const [opened, setOpened] = useState(defaultOpen);
  return (
    <details
      id={id}
      className="chapter"
      open={opened}
      onToggle={(event) => setOpened(event.currentTarget.open)}
    >
      <summary className="chapter-summary">
        <div className="chapter-summary-row">
          <h2>{title}</h2>
          <span className="chapter-toggle" data-closed={t.readAnalysis} data-open={t.hideAnalysis} />
        </div>
        {extra}
        {takeaway ? <p className="chapter-takeaway">{takeaway}</p> : null}
      </summary>
      <div className="chapter-body">{children}</div>
    </details>
  );
}
